// @flow
import React from 'react';
import PropTypes from 'prop-types';
import ChevronIcon from '../../../common/icons/chevron/ChevronComponent';
import type { ProductSizeType } from '../../../../api/types/ProductSizes';
import './SelectionItem.scss';

const SelectionItemComponent = (props: ProductSizeType) => (
  <div
    data-selectitem
    className={`selection-item-component ${props.disabled ? 'selection-item-component--fade' : ''}`}
    onClick={props.onSelect}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
  >
    <a>
      <div className="selection-item-component__image-container">
        <img className="selection-item-component__image" src={props.image} alt={props.name} />
      </div>
      <div className="selection-item-component__copy-container">
        <span className="selection-item-component__name u-fontFamily-primaryMedium">{props.name}</span>
        <span className="selection-item-component__description u-fontFamily-secondary">{props.description}</span>
        <span className="selection-item-component__description--secondary">{props.subDescription}</span>
      </div>
      <span className="selection-item-component__link u-fontFamily-primaryMedium">
        {props.linkText}
        <ChevronIcon />
      </span>
    </a>
  </div>
);

SelectionItemComponent.displayName = 'SelectionItemComponent';

SelectionItemComponent.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  description: PropTypes.string,
  subDescription: PropTypes.string,
  linkText: PropTypes.string.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SelectionItemComponent;
